import { VueQueryPlugin } from '@tanstack/vue-query';
import type { App } from 'vue';

import { createAppQueryClient } from './queryClient';
import { setupQueryPersistence } from './setupPersistence';

export { queryKeys } from './queryKeys';
export { ENTITY_LIST_QUERY_OPTIONS, useQueryInitialLoading } from './constants';
export { createAppQueryClient } from './queryClient';
export * from './invalidate';
export { useAssignedPropertiesQuery } from './hooks/useAssignedPropertiesQuery';
export { useAccountPropertiesQuery } from './hooks/useAccountPropertiesQuery';
export { useTeamMembersQuery } from './hooks/useTeamMembersQuery';
export { useUnassignedPropertiesQuery } from './hooks/useUnassignedPropertiesQuery';
export { useClustersListQuery } from './hooks/useClustersListQuery';
export { useBrandsListQuery } from './hooks/useBrandsListQuery';
export { usePagesListQuery } from './hooks/usePagesListQuery';

let queryClient = createAppQueryClient();

export function getQueryClient() {
  return queryClient;
}

export function installQueryClient(app: App): Promise<void> {
  queryClient = createAppQueryClient();
  const restorePromise = setupQueryPersistence(queryClient);
  app.use(VueQueryPlugin, { queryClient });
  return restorePromise;
}
